import { useDispatch, useSelector } from "react-redux";
import {
  StyledImageContainer,
  StyledSubTitle,
  StyledSubTitle2,
  StyledSubTitle3,
  StyledTitle,
} from "../../../components/ModalComponents/StyledModalComponents";
import {
  currentlyEditingSleeperSelector,
  isIncorporateModalOpenSelector,
  setIsIncorporateModalOpen,
} from "../../../redux/slices/customNavigation";
import {
  getFirstName,
  getPainPointsInfoMessage,
  getPainPointsName,
  getPainPointsSVG,
  getSleepStyleInfoMessage,
  getSleepStyleName,
  getSleepStyleSVG,
  hasPainPoints,
  painPointsIndexReference,
} from "../../../utils/bedBuilder.utils";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";

import ContainedButton from "../../../components/Buttons/ContainedButton";

import React from "react";

import {
  isSingleSleeperSelector,
  primarySleeperPainPointsSelector,
  secondarySleeperPainPointsSelector,
} from "../../../redux/slices/mattressConfiguration";
import evrbed_pain_points_background from "../../../assets/images/evrbed_pain_points_background.svg";

import styled from "styled-components";
import useMediaQuery from "@mui/material/useMediaQuery";

const StyledTextContainer = styled.div`
  width: 35vw;
  height: 5vh;
  position: absolute;
  padding-left: 7vw;
  padding-right: 5vw;
`;

const StyledSVGContainer = styled.div`
  width: 5vw;
  height: 5vh;
`;

const SleeperPainPointsModal = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery("(min-width: 500px)");
  const isMediumScreen = useMediaQuery("(min-width: 768px)");
  const isLargeScreen = useMediaQuery("(min-width: 992px)");
  const isExtraLargeScreen = useMediaQuery("(min-width: 1200px)");
  const isIncorporateModalOpen = useSelector(isIncorporateModalOpenSelector);

  const isSingleSleeper = useSelector(isSingleSleeperSelector);

  const currentlyEditingSleeper = useSelector(currentlyEditingSleeperSelector);

  const editingSleeper1 = currentlyEditingSleeper === 1;

  const primarySleeperLastSelectedPainPoint = useSelector(
    state =>
      state.mattressConfiguration.mattressBuilder.primarySleeper
        .lastSelectedPainPoint
  );
  const secondarySleeperLastSelectedPainPoint = useSelector(
    state =>
      state.mattressConfiguration.mattressBuilder.secondarySleeper
        .lastSelectedPainPoint
  );

  const primarySleeperPainPoints = useSelector(
    primarySleeperPainPointsSelector
  );
  const secondarySleeperPainPoints = useSelector(
    secondarySleeperPainPointsSelector
  );

  const primarySleeperHasMultiplePainPoints =
    hasPainPoints(primarySleeperPainPoints).length > 1;
  const secondarySleeperHasMultiplePainPoints =
    hasPainPoints(secondarySleeperPainPoints).length > 1;

  const painPointsIndex =
    isSingleSleeper || editingSleeper1
      ? painPointsIndexReference[primarySleeperLastSelectedPainPoint]
      : painPointsIndexReference[secondarySleeperLastSelectedPainPoint];

  const primarySleeperBackPainText = primarySleeperHasMultiplePainPoints
    ? t("Multiple Pain Points")
    : `${getPainPointsName(painPointsIndex)} Pain`;
  const secondarySleeperBackPainText = secondarySleeperHasMultiplePainPoints
    ? t("Multiple Pain Points")
    : `${getPainPointsName(painPointsIndex)} Pain`;

  const painPointText =
    isSingleSleeper || editingSleeper1
      ? primarySleeperBackPainText
      : secondarySleeperBackPainText;

  return (
    <div
      className="col-5"
      style={{
        position: "relative",
        marginTop: isExtraLargeScreen ? "" : "30vh",
      }}
    >
      <StyledImageContainer className="mx-auto">
        <img
          style={{
            width: "30vw",
            height: "45vh",
          }}
          src={evrbed_pain_points_background}
        ></img>
      </StyledImageContainer>
      <StyledTextContainer
        style={{ marginTop: isExtraLargeScreen ? "-35vh" : "-30vh" }}
      >
        <div className="row">
          <StyledTitle
            className="col-6"
            style={{ color: theme.COLORS.BLUE.darkBlueGreen }}
          >
            {getFirstName()},<br></br>
            {t("You have")}: {painPointText}
          </StyledTitle>
          <img
            style={{
              width: "7vw",
              height: "7vh",
              marginLeft: "-1vw",
            }}
            src={getPainPointsSVG(painPointsIndex)}
          ></img>
        </div>
        <StyledSubTitle3
          className="col-9 text-center"
          style={{
            marginLeft: "-50px",
            color: theme.COLORS.BLUE.darkBlueGreen,
            marginTop: isExtraLargeScreen ? "3vh" : "2vh",
          }}
        >
          {t("Our Sleep Experts will")}
          <br></br>
          {getPainPointsInfoMessage(painPointsIndex)}
        </StyledSubTitle3>
        <StyledSubTitle2
          className="col-9 text-center"
          style={{
            color: theme.COLORS.BLUE.darkBlueGreen,
            marginLeft: "-40px",
            // marginTop: isExtraLargeScreen ? "5vh" : "2vh",
          }}
        >
          {t(
            "A sleep expert will be in touch to discuss your specific pain needs"
          )}
        </StyledSubTitle2>
        <ContainedButton
          className="col-auto"
          styles={{
            textTransform: "upperCase",
            fontSize: "0.8rem",
            marginTop: isExtraLargeScreen ? "1vh" : "-10vh",
          }}
          onClick={() =>
            dispatch(setIsIncorporateModalOpen(!isIncorporateModalOpen))
          }
        >
          {t("How does this affect")}
          <br></br>
          {t("my evrbed?")}
        </ContainedButton>
      </StyledTextContainer>
    </div>
  );
};

export default SleeperPainPointsModal;
